/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { BreadCrumb } from "@/components/templates";
import { FC, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { EntretienCreation, creationData } from "../creation/data";
import { entretienData } from "../entretien/data";
import { usePathname, useRouter } from "next/navigation";
import Image, { StaticImageData } from "next/image";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import uniqid from "uniqid";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper/types";
import $ from "jquery";
import _ from "lodash";
import arrow_down from "../../../assets/images/arrow_down.png";
import arrow_up from "../../../assets/images/arrow_up.png";
import "./swiper.scss";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { MyH2 } from "@/components/atoms";
import { isTouchDevice } from "@/helpers";

gsap.registerPlugin(ScrollTrigger);

export const useSetSrollTop = () => {
  const pathname = usePathname();

  useEffect(() => {
    window.scroll({ top: 0 });
  }, [pathname]);
};

const animations = () => {
  const image = document.getElementById("hero-image");
  const imageContainer = document.getElementById("container-fixed");
  const navbarContainer = document.getElementById("navbar-container");
  const contents = document.getElementById("contents");
  const navbar = document.getElementById("navbar");
  let tl = null;
  let tl2 = null;
  let tl3 = null;
  if (image && imageContainer && navbarContainer && navbar && contents) {
    tl = gsap
      .timeline({
        scrollTrigger: {
          trigger: imageContainer,
          start: "top top",
          end: `+=${window.innerHeight}`,
          scrub: 1,
          pin: true,
          onEnter: () => {
            imageContainer.classList.remove("fixed-hero");
          },
          onLeave: () => {
            imageContainer.classList.add("fixed-hero");
          },
          onEnterBack: () => {
            imageContainer.classList.remove("fixed-hero");
          },
        },
      })
      .to(image, {
        delay: 0,
        width: "100%",
        height: "100%",
        duration: 0.5,
        ease: "circ.out",
      });

    const fiftyPercent = (50 * navbar.clientHeight) / 100;

    tl2 = gsap
      .timeline({
        scrollTrigger: {
          trigger: navbarContainer,
          start: "top top",
          end: `+=${window.innerHeight}`,
          scrub: 1,
          pin: true,
        },
      })
      .to(navbar, {
        top: -1 * (navbar.clientHeight + fiftyPercent),
      });
  }
  return [tl, tl2, tl3];
};

interface SliderProps {
  items: {
    title: string;
    text: string;
    image: string | StaticImageData;
  }[];
}

const Slider: FC<SliderProps> = ({ items = [] }) => {
  const handleChangeSlide = (swiper: SwiperType) => {
    const container = document.getElementById("slide-container");
    const paginationContainer = document.querySelector(
      ".swiper-pagination"
    ) as HTMLElement;
    if (container && paginationContainer) {
      if (swiper.activeIndex === items.length - 1) {
        container.style.paddingRight = "30px";
        container.style.paddingLeft = "0px";
        paginationContainer.style.marginLeft = "0px";
      } else {
        container.style.paddingRight = "0px";
        container.style.paddingLeft = "30px";
        paginationContainer.style.marginLeft = "-30px";
      }
    }
  };

  return (
    <Swiper
      spaceBetween={16}
      slidesPerView={1.1}
      onSlideChange={handleChangeSlide}
      modules={[Pagination]}
      pagination={{ clickable: true }}
    >
      {items.map(({ image, title, text }) => (
        <SwiperSlide key={uniqid()}>
          <div className={styles.slideItem_container}>
            <div className={styles.image_container_slide}>
              <Image src={image} fill alt={title} />
            </div>
            <div className={styles.descritpion_container}>
              <h3>{title}</h3>
              <div
                className={styles.text_slide}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const fusionEntretienCreation = [...creationData, ...entretienData];

const usePlan = (): EntretienCreation => {
  const router = useRouter();
  const [currentService, setCurrentService] = useState<EntretienCreation>(
    fusionEntretienCreation[0]
  );

  useEffect(() => {
    var observe1: MutationObserver | null = null;
    var observe2: MutationObserver | null = null;

    const planFuncExec = () => {
      $(function () {
        const el1 = document.getElementById("content-change-plan");
        const el2 = document.getElementById("content-change-plan-2");

        observe1 = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === "attributes") {
              const el = mutation.target as HTMLElement;
              const data = JSON.parse(
                el.getAttribute("data-json") as string
              ) as {
                url: string;
              };

              router.push(data.url);
            }
          });
        });

        observe2 = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === "attributes") {
              const el = mutation.target as HTMLElement;
              const data = JSON.parse(
                el.getAttribute("data-json") as string
              ) as {
                slug: string;
              };

              if (data.slug === "entretien") {
                setCurrentService({
                  title: "Entretien",
                  textDetail: `<p>Étape essentielle dans la vie d'un jardin, l'entretien permet de préserver,
                  soigner et, si besoin, maîtriser votre écrin de verdure.</p>`,
                } as any);
              } else {
                const item = fusionEntretienCreation.find(
                  (el) => el.slug === data.slug
                );
                if (item) {
                  setCurrentService(item);
                }
              }
            }
          });
        });

        if (el1) {
          observe1.observe(el1, {
            attributes: true, //configure it to listen to attribute changes
          });
        }

        if (el2) {
          observe2.observe(el2, {
            attributes: true,
          });
        }
      });
    };

    const execCallback = () => {
      if (!isTouchDevice()) {
        if (observe1 && observe2) {
          observe1.disconnect();
          observe2.disconnect();
          observe1 = null;
          observe2 = null;
        }
        setTimeout(() => {
          planFuncExec();
        }, 500);
      } else {
        observe1?.disconnect();
        observe2?.disconnect();
        observe1 = null;
        observe2 = null;
      }
    };

    execCallback();

    window.addEventListener("resize", execCallback);

    return () => {
      window.removeEventListener("resize4", execCallback);
      observe1?.disconnect();
      observe2?.disconnect();
      observe1 = null;
      observe2 = null;
    };
  }, []);

  return currentService;
};

export interface EntretienCreationDetailProps {
  type: "entretien" | "creation";
  slug: string;
  planSVG?: string;
}

export const EntretienCreationDetail: FC<EntretienCreationDetailProps> = ({
  type,
  slug,
  planSVG,
}) => {
  const mainData = type === "creation" ? creationData : entretienData;
  const currentData = mainData.find((el) => el.slug === slug);
  const router = useRouter();
  const [anims, setAnims] = useState<(gsap.core.Timeline | null)[]>([]);
  const [isTouchscreenState, setIsTouchScreenState] = useState<boolean>(false);

  useSetSrollTop();

  const currentService = usePlan();

  const handleClickServiceitem = (url: string) => () => {
    router.push(url);
  };

  const handleClickNavPlanItem = (direction: "up" | "down") => () => {
    const first = document.getElementById("first-item-plan");
    const last = document.getElementById("last-item-plan");

    if (first && last) {
      if (direction === "up") {
        window.scroll({ top: first.offsetTop - 40, behavior: "smooth" });
      } else {
        window.scroll({ top: last.offsetTop - 300, behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const loadAnim = () => {
      if (anims.length === 0) {
        setTimeout(() => {
          setAnims(animations());
        }, 500);
      } else {
        anims.forEach((el) => el?.kill());
        setAnims(animations());
      }
    };
    loadAnim();
    const updateScreenState = () => {
      setIsTouchScreenState(isTouchDevice());
    };
    updateScreenState();
    window.addEventListener("resize", updateScreenState);
    return () => {
      window.removeEventListener("resize", updateScreenState);
    };
  }, []);

  useEffect(() => {
    return () => {
      anims.forEach((el) => el?.kill());
    };
  }, [anims]);

  if (!currentData) {
    router.push(type === "creation" ? "/creation" : "/entretien");
    return null;
  }

  return (
    <div className="w-full">
      <div className={styles.header}>
        <div className={styles.navbar_container} id="navbar-container">
          <div className={styles.navbar_container_absolute} id="navbar">
            {/* <Navbar /> */}
          </div>
        </div>
        <div className={styles.container_fixed} id="container-fixed">
          <div className={styles.container_relative}>
            <div className={styles.image_container} id="hero-image">
              <img
                width={1920}
                height={1080}
                src={(currentData.heroImage as any).src as string}
                alt={currentData.title}
              />
            </div>
            <h1 className={styles.mainTitle}>{currentData.title}</h1>
          </div>
        </div>
      </div>
      <div className={styles.contents} id="contents">
        <div className={styles._block}>
          <BreadCrumb
            className={styles.bread_crumb}
            data={[
              {
                url: "/",
                label: "Accueil",
              },
              {
                url: type === "creation" ? "/creation" : "/entretien",
                label: type === "creation" ? "Création" : "Entretien",
              },
              {
                url: `${
                  type === "creation" ? "/creation" : "/entretien"
                }/${slug}`,
                label: currentData.title,
              },
            ]}
          />
          <h2 className={styles.title_h2}>
            Notre savoir-faire : {currentData.title}
          </h2>
          {!!currentData?.textDetail?.length && (
            <div
              className={styles.text_savoir_faire}
              dangerouslySetInnerHTML={{ __html: currentData.textDetail }}
            ></div>
          )}
          <div className={styles.left_desktop}>
            <div className={styles.block_orange} />
            <div className={styles.desciptions}>
              {(currentData.details?.items || []).map((item: any) => (
                <div key={uniqid()} className={styles.item}>
                  <div className={styles.item_left}>
                    <div className={styles.img_container}>
                      <Image
                        src={item.image}
                        width={434}
                        height={225}
                        alt={item.title}
                        quality={60}
                      />
                    </div>
                    <h3>{item.title}</h3>
                  </div>
                  <div
                    className={styles.item_right}
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className={styles.items_mobile} id="slide-container">
            <Slider items={currentData.details?.items || []} />
          </div>
        </div>
        <div className={styles.plan}>
          <MyH2>Nos Services</MyH2>
          {isTouchscreenState ? (
            <div className={styles.plan_mobile} id="first-item-plan">
              <div className={styles.navigation}>
                <div className={styles.navigation_container}>
                  <span onClick={handleClickNavPlanItem("up")}>
                    <Image src={arrow_up} alt="up" />
                  </span>
                  <span onClick={handleClickNavPlanItem("down")}>
                    <Image src={arrow_down} alt="down" />
                  </span>
                </div>
              </div>
              <div className={styles.items}>
                {_.orderBy(fusionEntretienCreation, ["title"], ["asc"]).map(
                  ({ logoPlan, title, textDetail, url }) => (
                    <div
                      key={uniqid()}
                      className={styles.service_item}
                      onClick={handleClickServiceitem(url)}
                    >
                      <Image src={logoPlan} alt={title} />
                      <h3>{title}</h3>
                      <div
                        className={styles.text}
                        dangerouslySetInnerHTML={{ __html: textDetail }}
                      />
                    </div>
                  )
                )}
              </div>
            </div>
          ) : (
            <>
              {planSVG && (
                <>
                  <div id="content-change-plan"></div>
                  <div id="content-change-plan-2"></div>
                  <div className={styles.text_content}>
                    <h3>{currentService.title}</h3>
                    <div
                      className={styles.details_text_container}
                      dangerouslySetInnerHTML={{
                        __html: currentService.textDetail,
                      }}
                    />
                  </div>
                  <div
                    className={styles.plan_container}
                    dangerouslySetInnerHTML={{ __html: planSVG }}
                  />
                </>
              )}
            </>
          )}
        </div>
        <div id="last-item-plan"></div>
      </div>
    </div>
  );
};
